import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';

//Services
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';
import { ChecklistService } from '../../checklist/services/checklist.service';
import { DailyReportsService } from '../../field/service/daily-reports.service';
import { EmployeeService } from '../services/employee.service';
import { SmService } from '../../../pages/sm/services/sm.service';
import { HomeService } from '../../../pages/home/services/home.service';
import { ClockInOutService } from '../../../core/services/clock-in-out.service';

//Models
import { LineType } from '../../../shared/model/line-type.model';
import { SimpleLookupResult } from '../../../type-definitions/general/general';

@Component({
  selector: 'app-clock-in-out',
  templateUrl: './clock-in-out.component.html',
  styleUrls: ['./clock-in-out.component.css'],
})
export class ClockInOutComponent implements OnInit, OnDestroy {
  @ViewChild('signaturePad', { static: false }) signaturePad: any;
  @ViewChild('clockInOutPage', { static: true }) clockInOutPage: ElementRef;
  portalSettings: any;
  employeeInfo: any;
  geolocationEnabled = false;
  requestingLocation = false;
  position: any = null;
  clockActionPerformed = false;
  performingClockAction = false;
  prefillJP = false;
  customMsg: any;
  tCClockIOIgnoreJobPhase = false;
  formData: any = {};
  loadingClockStatus = false;
  jobs: any = [];
  phases: any = [];
  clockStatus: any;
  clockMoment: moment.Moment;
  lastClockDisplay: string;
  requireSign: any;
  signatureData: any;
  clockIn: any;
  clockActionSuccess: any;
  message: string;
  rawImgData: any;
  signatureNEmpty: any;
  submitSignImg: any = null;
  hideClick: boolean;
  showClickMsg: boolean;
  signed = false;
  read = false;
  redBorder: boolean;
  disableSubmitSign: boolean;
  panelWidth: number;
  kioskLogin = false;
  params: any;
  redirectTimeout: any;
  types: LineType[] = [];
  isJobEnabled = false;
  isServiceEnabled = false;
  isUserFSTech: boolean;
  workOrderList: any = [];
  scopeList: any = [];
  payTypeList: any = [];
  lastClockinType: any;
  licensedUser: any = {};
  signaturePadOptions: Object = {
    canvasWidth: 550,
    canvasHeight: 150,
  };

  mealBreak: boolean = false;
  mealBreakSetting: { [key: string]: string } = {};
  ;
  mealBreakOptions: SimpleLookupResult[] = [
    { ComboType: null, DatabaseValue: 'N', DisplayValue: 'No' },
    { ComboType: null, DatabaseValue: 'Y', DisplayValue: 'Yes' },
  ];
  hadMealBreakToday: boolean = false;

  constructor(
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private employeeService: EmployeeService,
    private dailyReportsService: DailyReportsService,
    private checklistService: ChecklistService,
    private route: ActivatedRoute,
    private utilityService: UtilityService,
    private smService: SmService,
    private homeService: HomeService,
    private clockinoutService: ClockInOutService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
  }

  async ngOnInit(): Promise<void> {
    this.params = this.route.snapshot.queryParams;
    this.kioskLogin = this.params?.kioskLogin;
    this.prefillJP = this.portalSettings.PrefillPerviousJobPhase.ConfigValue == '1';
    this.customMsg = this.portalSettings.CustomVerbiageClockOutSign.ConfigValue;
    this.tCClockIOIgnoreJobPhase = this.portalSettings.TCClockIOIgnoreJobPhase.ConfigValue == '1';
    this.requireSign = this.portalSettings.RequireSignClockOut.ConfigValue == '1';
    this.isUserFSTech = this.employeeInfo.IsActiveTechnician;
    this.formData.selectedJob = null;
    this.formData.selectedPhase = null;
    this.formData.selectedType = null;
    this.formData.selectedWorkOrder = null;
    this.formData.selectedScope = null;
    this.formData.selectedPayType = null;
    this.formData.mealBreak = 'N';
    this.redBorder = false;
    var width = this.clockInOutPage?.nativeElement?.clientWidth;
    this.panelWidth = (width > 550 ? 550 : width) + 30;
    this.licensedUser = await this.homeService.getLicenseCounts(this.employeeInfo.PRCo, this.employeeInfo.Employee);
    this.getMealBreakSetting();
    this.createTypeDropDownValues();
    this.getLocation();
    this.getClockInStatus();
  }

  ngOnDestroy(): void {
    clearTimeout(this.redirectTimeout);
  }

  getMealBreakSetting() {
    if (this.portalSettings.ClockInMealBreakMinutes.ConfigValue != null) {
      this.portalSettings.ClockInMealBreakMinutes.ConfigValue.split(';').forEach((val: string) => {
        if (val) {
          const settingParts = val.split(',');
          this.mealBreakSetting[settingParts[0] + "," + settingParts[1]] = settingParts[2];
        }
      });
    }
  }

  showMealBreak() {
    return this.mealBreakSetting[this.employeeInfo.PRCo + "," + this.employeeInfo.PRGroup] != null && !this.hadMealBreakToday;
  }

  postClockAction(ignoreLocation: boolean) {
    if (!this.loadingClockStatus && !this.requestingLocation) {
      this.performingClockAction = true;
      var requestObj = {
        clockInTime: new Date().toISOString(),
        gPSLat: null,
        gPSLong: null,
        jCJMKeyID: null,
        jCJPKeyID: null,
        signatureData: null,
        clockTimeString: null,
        sMTripID: null,
        sMWorkOrderScopeID: null,
        sMPayType: null,
        mealBreak: this.formData.mealBreak == 'Y'
      };
      if (!ignoreLocation && this.position) {
        requestObj.gPSLat = this.position.coords.latitude;
        requestObj.gPSLong = this.position.coords.longitude;
      }
      if (this.formData.selectedType == 'J' && !this.clockStatus) {
        requestObj.jCJMKeyID = this.formData.selectedJob.JCJMKeyID;
        requestObj.jCJPKeyID = this.formData.selectedPhase.JCJPKeyID;
      } else if (this.formData.selectedType == 'S' && !this.clockStatus) {
        requestObj.sMTripID = this.formData.selectedWorkOrder.SMTripID;
        requestObj.sMWorkOrderScopeID = this.formData.selectedScope.SMWorkOrderScopeID;
        requestObj.sMPayType = this.formData.selectedPayType.DatabaseValue;
      }
      if (this.signatureData != null) requestObj.signatureData = this.signatureData;

      var currentTime = moment();
      requestObj.clockTimeString = currentTime.format('MM/DD/YYYY h:mm:ss a');

      this.employeeService.postClockAction(requestObj).then((response: any) => {
        if (response != null) {
          this.clockActionPerformed = true;
          this.clockIn = response.resultClockAction;
          this.clockActionSuccess = response.success;
          if (response.success) {
            if (response.resultClockAction) {
              this.message = 'Successfully clocked in at ' + currentTime.format('hh:mm A');
              this.redirectToLogin();
            } else if (response.resultClockAction == false) {
              this.message = 'Successfully clocked out at ' + currentTime.format('hh:mm A');
              this.redirectToLogin();
            }
          } else {
            this.message = response.error;
          }
        }
      });
    }
  }

  jobChanged() {
    this.formData.selectedPhase = null;
    this.dailyReportsService.setJob(this.formData.selectedJob.JCJMKeyID, this.employeeInfo.UserKeyID);
    this.getPhases();
  }

  typeChanged() {
    if (this.formData.selectedType == 'J') {
      this.resetJobDropdown();
      this.getJobs();
    } else {
      this.resetServiceDropdown();
      this.getWorkOrder();
    }
  }

  resetJobDropdown() {
    this.formData.selectedJob = null;
    this.formData.selectedPhase = null;
  }

  resetServiceDropdown() {
    this.formData.selectedWorkOrder = null;
    this.formData.selectedScope = null;
    this.formData.selectedPayType = null;
  }

  createTypeDropDownValues() {
    this.types = this.clockinoutService.getEnabledLineTypes(this.licensedUser, this.isUserFSTech);
    this.isJobEnabled = this.types?.some(type => type.Value == 'J');
    this.isServiceEnabled = this.types?.some(type => type.Value == 'S');
  }

  loadJobOrServiceDropDown() {
    this.formData.selectedType =
      this.types?.length == 1 || !this.types?.some(lineType => lineType.Value == this.lastClockinType)
        ? this.types[0].Value
        : this.lastClockinType;
    this.formData.selectedType == 'J' ? this.getJobs() : this.getWorkOrder();
  }

  async getWorkOrder(): Promise<void> {
    const response = await this.smService.getWorkOrderTripsByEmployee(this.employeeInfo.Employee, this.employeeInfo.PRCo);
    if (response != null && Array.isArray(response)) {
      this.workOrderList = [];
      this.workOrderList = response.map((val: any) => {
        const scheduledDateDisplay = val.ScheduledDate != null ? moment(val.ScheduledDate).utc().format('DD/MMM') : '';
        return {
          WorkOrder: val.WorkOrder,
          SMTripID: val.SMTripID,
          SMWorkOrderID: val.SMWorkOrderID,
          ScheduledDateDisplay: scheduledDateDisplay,
          Display: (scheduledDateDisplay != '' ? scheduledDateDisplay + ' - ' : '') + 'WO #' + val.WorkOrder + ' ' + val.TripDescription,
          SMCo: val.SMCo,
        };
      });
    }
  }

  workOrderChanged() {
    if (this.formData.selectedWorkOrder != null) {
      this.formData.selectedScope = null;
      this.formData.selectedPayType = null;
      this.getScope();
      this.getPayType();
    }
  }

  async getScope(): Promise<void> {
    this.scopeList = [];
    const response = await this.smService.getWorkOrderScopes('?sMWorkOrderID=' + this.formData.selectedWorkOrder.SMWorkOrderID);
    if (response != null && Array.isArray(response)) {
      this.scopeList = response;
      this.scopeList = response.map(val => ({
        ...val,
        Display: val.Scope + ' - ' + val.ScopeDetails,
      }));
    }
  }

  async getPayType(): Promise<void> {
    this.payTypeList = [];
    var smCo = this.formData.selectedWorkOrder?.SMCo;
    if (smCo != null) {
      const response = await this.smService.getSMPayTypes(smCo);
      if (response != null && Array.isArray(response)) {
        this.payTypeList = response.map(val => ({
          ...val,
          Display: val.DatabaseValue + ' - ' + val.DisplayValue,
        }));
      }
    }
  }

  disableClockinButton() {
    return (
      this.performingClockAction ||
      //disable if Type is J but job/phase combined is not selected
      ((this.formData.selectedJob?.JCJMKeyID == null || this.formData.selectedPhase?.JCJPKeyID == null) &&
        !this.tCClockIOIgnoreJobPhase &&
        this.formData.selectedType == 'J') ||
      //disable if Type is J but job or phase is not selected
      (this.formData.selectedType == 'J' &&
        this.tCClockIOIgnoreJobPhase &&
        (this.formData.selectedJob == null || this.formData.selectedPhase == null)) ||
      //disable if Type is S but work order/scope/pay type combined is not selected
      (this.formData.selectedType == 'S' &&
        (this.formData.selectedWorkOrder == null || this.formData.selectedScope == null || this.formData.selectedPayType == null))
    );
  }

  canMealBreakClockIn() {
    if (this.mealBreakSetting[this.employeeInfo.PRCo + "," + this.employeeInfo.PRGroup] != null) {
      const mealBreakThreshold = parseInt(this.mealBreakSetting[this.employeeInfo.PRCo + "," + this.employeeInfo.PRGroup]);
      //convert utc clock in time to local time
      const lastClockOut = moment(this.clockMoment.format('YYYY-MM-DD HH:mm:ss'));
      const minutesElapsed = moment().diff(lastClockOut, 'minutes');
      if (minutesElapsed < mealBreakThreshold)
        return false;
    }
    return true;
  }

  clockOutClicked() {
    if (this.requireSign) {
      this.checkSigned();
      if (this.formData.typeSign) {
        this.signatureData = this.rawImgData;
        this.postClockAction(false);
      } else if (this.signatureNEmpty) {
        this.signatureData = this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, '');
        this.postClockAction(false);
      }
    }
  }

  clickSign(type: any) {
    if (this.signaturePad.isEmpty()) {
      this.formData.typeSign = true;
      this.checklistService.getTypeSign(type).then((response: any) => {
        if (response != null) {
          this.rawImgData = response;
          this.submitSignImg = 'data:image/png;base64,' + response;
        }
      });
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  clear() {
    if (this.signaturePad != null) this.signaturePad.clear();
    this.signatureNEmpty = false;
    this.rawImgData = null;
    this.submitSignImg = null;
    this.formData.typeSign = false;
    this.showClickMsg = false;
    this.hideClick = false;
  }

  searchJobs(term: string, item: any) {
    term = term.trim().toLowerCase();
    return item.JCJMKeyID?.toString().indexOf(term) > -1 || item.DisplayValue?.toLowerCase().indexOf(term) > -1;
  }

  searchPhases(term: string, item: any) {
    term = term.trim().toLowerCase();
    return (
      item.JCJPKeyID?.toString().indexOf(term) > -1 ||
      item.PhaseDescription?.toLowerCase().indexOf(term) > -1 ||
      item.PhaseGroup?.toString().indexOf(term) > -1
    );
  }

  private getClockInStatus() {
    this.loadingClockStatus = true;
    var currentTime = moment();
    var currentTimeString = currentTime.format('MM/DD/YYYY h:mm:ss a');
    var requestParam = 'fromFieldKiosk=' + false + '&currentTimeString=' + currentTimeString + '&where=' + 2;
    this.employeeService.getClockInStatus(requestParam).then((response: any) => {
      if (response != null) {
        this.clockStatus = response.ClockAction;
        this.lastClockinType = response.LastUsedClockinType == null ? 'J' : response.LastUsedClockinType;
        this.loadingClockStatus = false;
        this.clockMoment = moment.utc(response.ClockTime);
        this.lastClockDisplay = this.clockMoment.format('hh:mm A');
        this.mealBreak = response.MealBreak == 'Y';
        this.hadMealBreakToday = response.HadMealBreakToday;
        if (!this.clockStatus && (this.isJobEnabled || this.isServiceEnabled)) {
          this.loadJobOrServiceDropDown();
        } else {
          //automatic posting of clock action
          if (!this.requestingLocation &&
            this.geolocationEnabled &&
            (!this.requireSign || !this.clockStatus) &&
            (!this.clockStatus || !this.showMealBreak()) &&
            (!this.mealBreak || this.canMealBreakClockIn())) {
            this.postClockAction(false);
          }
        }
      }
    });
  }

  private redirectToLogin() {
    this.redirectTimeout = setTimeout(() => {
      this.performLoginRedirect();
    }, 5000);
  }

  performLoginRedirect() {
    let loginURL = '/Account/Login';
    this.utilityService.isLoggedOut = true;
    if (this.kioskLogin) {
      window.location.href = '/Account/Logout?kioskLogout=true';
      loginURL = '/Account/Kiosklogin';
    } else {
      window.location.href = '/Account/Logout';
    }
    window.history.replaceState(null, null, loginURL);
  }

  private getLocation() {
    this.requestingLocation = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        setTimeout(() => {
          this.requestingLocation = false;
          this.geolocationEnabled = true;
          this.position = position;

          //Prevent auto clock action if user is using job/phase while clocking in, or if user is using signature while clocking out, or if still loading clock status
          if (
            ((!this.isJobEnabled && !this.isServiceEnabled) || this.clockStatus) &&
            !this.loadingClockStatus &&
            (!this.requireSign || !this.clockStatus) &&
            (!this.clockStatus || !this.showMealBreak()) &&
            (!this.mealBreak || this.canMealBreakClockIn())
          ) {
            this.postClockAction(false);
          }
        }, 1000);
      });
      this.requestingLocation = false;
    } else {
      this.requestingLocation = false;
    }
  }

  private getJobs() {
    this.employeeService.getJobs('TC', '').then((response: any) => {
      if (response != null) {
        var jobs = response;
        jobs.forEach(val => {
          val.DisplayValue = 'JCCo ' + val.JCCo + ' - ' + val.JobDisplayName;
          if (this.employeeInfo.LastUsedJCJMKeyID != null && val.JCJMKeyID == this.employeeInfo.LastUsedJCJMKeyID && this.prefillJP) {
            this.formData.selectedJob = val;
          }
        });
        if (this.formData.selectedJob != null) this.getPhases();
        else {
          this.phases = [{ JCJPKeyID: null, Phase: '', PhaseDescription: 'No Phase', PhaseGroup: null }];
          this.formData.selectedPhase = this.phases[0];
        }
        this.jobs = jobs;
        if (this.tCClockIOIgnoreJobPhase) {
          this.jobs.unshift({ JCJMKeyID: null, DisplayValue: 'No Job', JCCo: null, Job: '', JobDescription: '', JobDisplayName: '' });
          if (this.formData.selectedJob == null) this.formData.selectedJob = this.jobs[0];
        }
      }
    });
  }

  private getPhases() {
    this.phases = [];
    if (this.formData.selectedJob.JCJMKeyID != null) {
      this.employeeService.getPhasesByJCJMKeyID(this.formData.selectedJob.JCJMKeyID, true).then((response: any) => {
        if (response != null) {
          this.phases = response;
          if (this.prefillJP) {
            this.phases.forEach(val => {
              if (this.employeeInfo.LastUsedJCJPKeyID != null && this.employeeInfo.LastUsedJCJPKeyID == val.JCJPKeyID) {
                this.formData.selectedPhase = val;
              }
            });
          }
          if (this.tCClockIOIgnoreJobPhase) {
            this.phases.unshift({ JCJPKeyID: null, Phase: '', PhaseDescription: 'No Phase', PhaseGroup: null });
            if (this.formData.selectedPhase == null) this.formData.selectedPhase = this.phases[0];
          }
        }
      });
    } else {
      if (this.tCClockIOIgnoreJobPhase) {
        this.phases.unshift({ JCJPKeyID: null, Phase: '', PhaseDescription: 'No Phase', PhaseGroup: null });
        if (this.formData.selectedPhase == null) this.formData.selectedPhase = this.phases[0];
      }
    }
  }

  private checkSigned() {
    if (this.signaturePad.isEmpty() == false) {
      this.signatureNEmpty = true;
      this.redBorder = false;
      this.disableSubmitSign = true;
    } else {
      this.redBorder = true;
    }
  }
}
